import { render, staticRenderFns } from "./AutoPaySectionPage.vue?vue&type=template&id=60a57b66&"
import script from "./AutoPaySectionPage.vue?vue&type=script&lang=js&"
export * from "./AutoPaySectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports